/*
  When payment terms modal is opened, close open quickview to fix stacking issue
*/

(() => {
  window.termsModals = {};
  window.termsModalsQuickviews = {};

  /* Wait for terms modal to open, then close open quickview, and reopen quickview when tems modal closes */
  const watchTermsModalVisibility = id => {
    const termsModalRoot = window.termsModals[id].shadowRoot.querySelector('[data-testid="authorize-modal-container"]');
    const termsModalVisibileObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (termsModalRoot.classList.contains('visible')) {
            const openQuickview = document.querySelector('[data-quickview-menu][open]');
            if (openQuickview) {
              window.termsModalsQuickviews[id] = openQuickview.closest('quick-view');
              window.termsModalsQuickviews[id].close();
            }
          } else {
            if (window.termsModalsQuickviews[id]) window.termsModalsQuickviews[id].open();
          }
        }
      });
    });

    termsModalVisibileObserver.observe(termsModalRoot, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  /* Watch body for shopify-payment-terms modals being added to the DOM */
  const termsObserver = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type !== 'childList') return;
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE || typeof node.hasAttribute !== 'function' || !node.hasAttribute('data-portal-instance-id')) return;
        const id = node.dataset.portalInstanceId;
        window.termsModals[id] = node;
        watchTermsModalVisibility(id);
      });
    }
  });

  termsObserver.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });
})();
